// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__UXgQX","element":"style__element__NFhFS","bubbleMessage":"style__bubbleMessage__TckdQ","readOnly":"style__readOnly__KpPaZ"};